<template>
  <base-container ref="container" style="height: 100%" :isLoading="loading">
    <ArtisanGrid
      ref="record"
      metaKey="ZlScheduleRecord"
      :query="query"
      @buildPlan="createPlan"
      @verifyPlan="verifyPlan"
    >
    </ArtisanGrid>
    <artisan-drawer
      ref="dialog"
      :title="dialog.title"
      :visible.sync="dialog.isShow"
      direction="right"
      size="90%"
      :isLoading="dialog.loading"
    >
      <ResourceSchedule
        v-if="dialog.isShow"
        :resId="query.resourceId"
        :start="row.startDate"
        :end="row.endDate"
        :apps="apps"
      ></ResourceSchedule>
    </artisan-drawer>
  </base-container>
</template>

<script>
import { buildPlan } from "@/api/zl/resource";
import ResourceSchedule from "./ResourceSchedule.vue";
import { list as appList } from "@/api/sys/app";
export default {
  components: { ResourceSchedule },
  props: ["query"],
  data() {
    return {
      loading: false,
      dialog: {
        title: "",
        isShow: false,
        loading: false,
      },
      row: {},
      apps: [],
    };
  },
  created() {
    appList().then((res) => {
      this.apps = res.data.data;
    });
  },
  methods: {
    createPlan() {
      this.$refs.container
        .confirm({ msg: "确认生成新一期的排班计划？" })
        .then(() => {
          this.loading = true;
          buildPlan(this.query.resourceId)
            .then(() => {
              this.loading = false;
              this.$refs.record.reload();
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    verifyPlan(row) {
      this.row = row;
      this.dialog.title = "排班审核--" + row.startDate + "~" + row.endDate;
      this.dialog.isShow = true;
    },
  },
};
</script>

<style scoped>
</style>